export class TableSorter {
  sortName: string = '';
  sortOrder: string = 'asc';

  constructor(sortName: string = '', sortOrder: string = 'asc') {
    this.sortName = sortName;
    this.sortOrder = sortOrder;
  }
}
